module.exports = __webpack_public_path__ + "img/phone.1d7e4344.png";